/**
 * Wagamour V2 modal shell constants.
 * Behavioral parity target: ModalDialog / BottomSheet (future migration).
 */

/** Above app-beta `#bottom-navigation` (z-index 99999) and diag overlays. */
export const wagamourV2ModalZIndex = {
  backdrop: 110_000,
  panel: 110_001,
} as const

export const wagamourV2ModalMaxHeight = {
  center:
    'calc(100dvh - max(12px, env(safe-area-inset-top, 0px)) - max(12px, env(safe-area-inset-bottom, 0px)) - 16px)',
  sheet:
    'min(92dvh, calc(100dvh - max(0px, env(safe-area-inset-top, 0px))))',
} as const

export const wagamourV2ModalBackdrop = {
  background: 'rgba(8, 4, 2, 0.58)',
  backdropBlur: '12px',
} as const
